// Copyright Square, Inc.
import { CUSTOMER_DATA_FRAMEWORK } from "../CustomerDataFramework.js";
/**
 * @see PaycheckDepositFirstFundEvent
 */
export var PaycheckDepositFirstFund = function (_a) {
    var depositToken = _a.depositToken, customerToken = _a.customerToken, amount = _a.amount, currencyCode = _a.currencyCode;
    return ({
        name: "Paycheck Deposit FirstFund",
        parameters: {
            cdf_entity: "Paycheck",
            cdf_action: "Deposit",
            deposit_token: depositToken !== undefined && depositToken !== null ? depositToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            customer_token: customerToken !== undefined && customerToken !== null ? customerToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            amount: amount !== undefined && amount !== null ? amount.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            currency_code: currencyCode !== undefined && currencyCode !== null ? currencyCode.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see PaycheckDepositFundEvent
 */
export var PaycheckDepositFund = function (_a) {
    var depositToken = _a.depositToken, customerToken = _a.customerToken, amount = _a.amount, currencyCode = _a.currencyCode;
    return ({
        name: "Paycheck Deposit Fund",
        parameters: {
            cdf_entity: "Paycheck",
            cdf_action: "Deposit",
            deposit_token: depositToken !== undefined && depositToken !== null ? depositToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            customer_token: customerToken !== undefined && customerToken !== null ? customerToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            amount: amount !== undefined && amount !== null ? amount.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            currency_code: currencyCode !== undefined && currencyCode !== null ? currencyCode.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see PaycheckPBAStatusFirstUnlockedEvent
 */
export var PaycheckPBAStatusFirstUnlocked = function (_a) {
    var customerToken = _a.customerToken;
    return ({
        name: "Paycheck PBAStatus FirstUnlocked",
        parameters: {
            cdf_entity: "Paycheck",
            cdf_action: "PBAStatus",
            customer_token: customerToken !== undefined && customerToken !== null ? customerToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see PaycheckPBAStatusUnlockedEvent
 */
export var PaycheckPBAStatusUnlocked = function (_a) {
    var customerToken = _a.customerToken, reason = _a.reason;
    return ({
        name: "Paycheck PBAStatus Unlocked",
        parameters: {
            cdf_entity: "Paycheck",
            cdf_action: "PBAStatus",
            customer_token: customerToken !== undefined && customerToken !== null ? customerToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            reason: reason !== undefined && reason !== null ? reason.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see PaycheckPBAStatusExpiredEvent
 */
export var PaycheckPBAStatusExpired = function (_a) {
    var customerToken = _a.customerToken;
    return ({
        name: "Paycheck PBAStatus Expired",
        parameters: {
            cdf_entity: "Paycheck",
            cdf_action: "PBAStatus",
            customer_token: customerToken !== undefined && customerToken !== null ? customerToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
